import { UNIFIED_GRAPH } from 'utils/constants';

import { useCallback } from 'react';

import { DocumentNode, useLazyQuery } from '@apollo/client';

export const useUsersSearch = <T,>(
  query: DocumentNode,
  isUnifiedQuery: boolean = false,
  mapFunction: (data: unknown) => T[],
  dataPath: string,
  initialVariables?: Record<string, unknown>,
  fetchPolicy?: 'cache-first' | 'cache-and-network' | 'network-only' | 'no-cache'
): {
  handleSearch: (search: string, additionalVariables?: Record<string, unknown>) => Promise<T[]>;
} => {
  const [executeQuery] = useLazyQuery(query, {
    ...(isUnifiedQuery && { context: { clientName: UNIFIED_GRAPH } }),
    ...(fetchPolicy && { fetchPolicy }),
  });

  const handleSearch = useCallback(
    async (search: string, additionalVariables?: Record<string, unknown>) => {
      const searchVariables = {
        searchTerm: search,
        ...initialVariables,
        ...additionalVariables,
      };

      const res = await executeQuery({ variables: searchVariables });
      const pathArray = dataPath.split('.');
      const data = pathArray.reduce((acc, key) => acc?.[key], res?.data);
      return mapFunction(data);
    },
    [executeQuery, initialVariables, dataPath, mapFunction]
  );

  return { handleSearch };
};
